import React, { useState, useEffect } from "react";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";
import { calculateFinePerMinute } from "../../utils/helper";
import moment from "moment";
import { set } from "react-hook-form";

const OvertimeModal = ({ item, staffs, baseUrl, openToast, onClose, fetchAttendance }) => {
  const [overTimelateHour, setOverTimelateHour] = useState("00:00");
  const [overTimeSalaryTime, setOverTimeSalaryTime] = useState(1);
  const [overTimeLateOutAmount, setOverTimeLateOutAmount] = useState(0);

  const [overTimeEarlyHour, setOverTimeEarlyHour] = useState("00:00");
  const [overTimeEarlySalaryTime, setOverTimeEarlySalaryTime] = useState(1);
  const [overTimeEarlyOutAmount, setOverTimeEarlyAmount] = useState(0);

  const [perMinSalary, setPerMinSalary] = useState(0);
  const [selectedStaffSalary, setSelectedStaffSalary] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const formatMinutesToHHMM = (minutes) => {
    const duration = moment.duration(minutes, "minutes");
    const hours = Math.floor(duration.asHours());
    const mins = Math.floor(duration.asMinutes() % 60);
    return `${String(hours).padStart(2, "0")}:${String(mins).padStart(2, "0")}`;
  };

  console.log("render overtime", item);

  const calculateDynamicOvertime = (punchRecord) => {
    if (punchRecord?.[0]?.Overtime) {
      // If Overtime record exists, use it
      return {
        earlyInMinutes: moment
          .duration(punchRecord?.[0]?.Overtime.earlyCommingEntryHoursTime)
          .asMinutes(),
        lateOutMinutes: moment
          .duration(punchRecord?.[0]?.Overtime.lateOutOvertimeHoursTime)
          .asMinutes(),
      };
    }

    if (!punchRecord?.[0]?.shift) {
      return { earlyInMinutes: 0, lateOutMinutes: 0 };
    }

    console.log(
      punchRecord?.[0]?.shift.shiftStartTime,
      punchRecord?.[0]?.shift.shiftEndTime
    );

    const shiftStart = moment(punchRecord?.[0]?.shift.shiftStartTime, "hh:mm A");
    const shiftEnd = moment(punchRecord?.[0]?.shift.shiftEndTime, "hh:mm A");

    let punchIn = null;
    let punchOut = null;

    if (punchRecord?.[0]?.punchIn?.punchInTime) {
      punchIn = moment(punchRecord?.[0]?.punchIn.punchInTime);
      shiftStart.set({
        year: punchIn.year(),
        month: punchIn.month(),
        date: punchIn.date(),
      });
    }

    if (punchRecord?.[0]?.punchOut?.punchOutTime) {
      punchOut = moment(punchRecord?.[0]?.punchOut.punchOutTime);
      shiftEnd.set({
        year: punchOut.year(),
        month: punchOut.month(),
        date: punchOut.date(),
      });
    }

    if (shiftEnd.isBefore(shiftStart)) {
      shiftEnd.add(1, "day");
    }

    const earlyInMinutes = punchIn
      ? Math.max(0, shiftStart.diff(punchIn, "minutes"))
      : 0;
    const lateOutMinutes = punchOut
      ? Math.max(0, punchOut.diff(shiftEnd, "minutes"))
      : 0;

    console.log(earlyInMinutes, lateOutMinutes);

    return { earlyInMinutes, lateOutMinutes };
  };

  useEffect(() => {
    if (item.punchRecord) {
      let salary = item?.staffDetails?.SalaryDetails[0]?.ctc_amount ?? 0;
      let minSalary = calculateFinePerMinute(salary, 30, 8);
      setSelectedStaffSalary(salary);
      setPerMinSalary(minSalary);
      if (item?.punchRecord?.[0]?.Overtime) {
        setOverTimeEarlyHour(
          item?.punchRecord?.[0]?.Overtime?.earlyCommingEntryHoursTime
        );
        setOverTimeEarlyAmount(
          item?.punchRecord?.[0]?.Overtime?.earlyCommingEntryAmount
        );
        setOverTimeEarlySalaryTime(
          item?.punchRecord?.[0]?.Overtime?.earlyEntryAmount
        );
        setOverTimelateHour(
          item?.punchRecord?.[0]?.Overtime?.lateOutOvertimeHoursTime
        );
        setOverTimeLateOutAmount(
          item?.punchRecord?.[0]?.Overtime?.lateOutOvertimeAmount
        );
        setOverTimeSalaryTime(item?.punchRecord?.[0]?.Overtime?.lateOutAmount);
      } else {
        const { earlyInMinutes, lateOutMinutes } = calculateDynamicOvertime(
          item?.punchRecord
        );

        setOverTimeEarlyHour(formatMinutesToHHMM(earlyInMinutes));
        setOverTimelateHour(formatMinutesToHHMM(lateOutMinutes));
        setOverTimeEarlyAmount(earlyInMinutes * minSalary);
        setOverTimeLateOutAmount(lateOutMinutes * minSalary);
      }
    }
  }, [item]);

  const handleChangeTime = (field, value, amount) => {
    const formattedTime = value?.format("HH:mm");
    const [hours, minutes] = formattedTime.split(":").map(Number);
    const totalMinutes = hours * 60 + minutes;
    const perMinSalary = calculateFinePerMinute(selectedStaffSalary, 30, 8);

    switch (field) {
      case "lateOut":
        setOverTimelateHour(formattedTime);
        setOverTimeLateOutAmount(perMinSalary * totalMinutes * amount);
        break;
      case "earlyIn":
        setOverTimeEarlyHour(formattedTime);
        setOverTimeEarlyAmount(perMinSalary * totalMinutes * amount);
        break;
    }
  };

  const applyOverTime = async () => {

    if (!item.punchRecord[0].shift) {
      openToast("Please Select Shift for " + item.punchRecord[0].status + " status", "warning");
      return;
    }

    setIsLoading(true);
    const data = {
      earlyCommingEntryHoursTime: overTimeEarlyHour,
      lateOutOvertimeHoursTime: overTimelateHour,
      earlyCommingEntryAmount: Number(overTimeEarlyOutAmount),
      earlyEntryAmount: Number(overTimeEarlySalaryTime),
      lateOutOvertimeAmount: Number(overTimeLateOutAmount),
      lateOutAmount: Number(overTimeSalaryTime),
      totalAmount: Number(
        overTimeLateOutAmount * overTimeSalaryTime +
        overTimeEarlyOutAmount * overTimeEarlySalaryTime
      ),
      staffId: item.staffId,
      punchRecordId: item.punchRecord?.[0]?.id,
    };

    try {
      const result = await fetch(`${baseUrl}overtime/create`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${localStorage.getItem(
            "flowChangerAuthToken"
          )}`,
        },
        body: JSON.stringify(data),
      });

      if (result.ok) {
        openToast("Overtime Applied Successfully", "success");
        onClose();
        fetchAttendance()
      } else {
        openToast("Something went wrong", "error");
      }
    } catch (err) {
      console.error(err);
      openToast("Something went wrong", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="z-50 fixed inset-0 flex justify-center items-center bg-[#ffffffbf] bg-opacity-50 p-[10px]">
      <div className="bg-white shadow-cs p-6 rounded-lg w-full max-w-lg h-full sm:h-auto overflow-y-scroll scroll-bar-design">
        <h2 className="mb-4 font-semibold text-[18px] text-[black] text-xl">
          Overtime
        </h2>
        <p className="mb-4 text-[14px]">
          {item.staffDetails.User.name} |{" "}
          {new Date(item.punchRecord?.[0]?.punchDate).toLocaleDateString()}
        </p>

        <OvertimeSection
          title="Late Out"
          hours={overTimelateHour}
          onChangeTime={(value) =>
            handleChangeTime("lateOut", value, overTimeSalaryTime)
          }
          salaryTime={overTimeSalaryTime}
          onChangeSalaryTime={setOverTimeSalaryTime}
          amount={overTimeLateOutAmount}
          perMinSalary={perMinSalary}
        />

        <OvertimeSection
          title="Early In"
          hours={overTimeEarlyHour}
          onChangeTime={(value) =>
            handleChangeTime("earlyIn", value, overTimeEarlySalaryTime)
          }
          salaryTime={overTimeEarlySalaryTime}
          onChangeSalaryTime={setOverTimeEarlySalaryTime}
          amount={overTimeEarlyOutAmount}
          perMinSalary={perMinSalary}
        />

        <div className="mt-4 mb-4">
          <span className="text-[12px]">Total Amount</span>
          <p className="text-[14px]">
            {(
              overTimeLateOutAmount * overTimeSalaryTime +
              overTimeEarlyOutAmount * overTimeEarlySalaryTime
            ).toFixed(2)}
          </p>
        </div>

        <div className="flex items-center gap-[4px] mb-4">
          <input type="checkbox" id="sendSms" />
          <label htmlFor="sendSms" className="text-[14px]">
            Send SMS to Staff
          </label>
        </div>

        {perMinSalary === 0 && (
          <p className="mb-4 w-full text-[#ff0000] text-center text-sm">
            Please add {item.staffDetails.User.name}'s salary before
            applying overtime.
          </p>
        )}

        <div className="flex flex-col gap-[10px]">
          <button
            disabled={perMinSalary === 0 || isLoading}
            onClick={applyOverTime}
            className="border-[#27004a] bg-[#27004a] hover:bg-[#ffff] disabled:opacity-50 px-4 py-2 border rounded-md text-white hover:text-[#27004a] transition-all disabled:cursor-not-allowed"
          >
            {isLoading ? "Applying Overtime..." : " Apply Overtime"}
          </button>
          <button
            onClick={onClose}
            className="bg-[#27004a] px-4 py-2 rounded-md text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const OvertimeSection = ({
  title,
  hours,
  onChangeTime,
  salaryTime,
  onChangeSalaryTime,
  amount,
  perMinSalary,
}) => (
  <div className="mb-4">
    <p className="mb-2 font-medium text-[14px]">{title}</p>
    <div className="flex sm:flex-row flex-col items-start sm:items-center gap-[4px] sm:gap-[20px] mb-2">
      <div className="w-full sm:w-[33%]">
        <p className="text-[12px]">Hours</p>
        <TimePicker
          showSecond={false}
          className="w-full sm:w-auto"
          onChange={onChangeTime}
          format="HH:mm"
          inputReadOnly
          value={moment(hours, "HH:mm")}
        />
        <p className="text-[12px]">
          Amount: {(amount * salaryTime).toFixed(2)}
        </p>
      </div>
      <div className="flex sm:flex-row flex-col gap-[10px] sm:gap-[28px] w-full sm:w-[66%]">
        <div className="w-[100%]">
          <select
            value={salaryTime}
            onChange={(e) => onChangeSalaryTime(parseFloat(e.target.value))}
            className="border-[#c9c9c9] pt-[6px] pr-[20px] pb-[6px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
          >
            <option value={1}>1x Salary</option>
            <option value={1.5}>1.5x Salary</option>
          </select>
        </div>
        <div className="">
          <p className="p-[6px] rounded-md w-full sm:w-[124px] text-[14px] select-pe">
            {perMinSalary.toFixed(2)} Per Min
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default OvertimeModal;
